import React, { Component } from 'react';
import Header from './CHeader';
import "../css/Welcome.css";
import { Link } from 'react-router-dom';
class Welcome extends Component {
    render() {
        return (
            <div>
                <Header isTos={false} />
                <div className="container mt card cd">
                    <div className="smallheader">WELCOME TO THE</div>
                    <div className="welcomemessage">Microsoft Community Tenant</div>
                    <div className="details">YOU ARE NOW ON THE LIST - YOU WILL NOW BE ABLE TO MONITOR YOUR TEAM MEMBERS</div>
                    <Link to={`/memberslist`}><div className="getstarted">Get Started</div></Link>
                </div>
            </div>
        );
    }
}

export default Welcome;
